module.exports = __webpack_public_path__ + "static/media/classes.5e28a7cb.svg";